import { Bar, mixins } from "vue-chartjs";
import ChartDataLabels from 'chartjs-plugin-datalabels';

const { reactiveProp } = mixins
export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: ["chartData", "options","dataLabel"],
    data: () => ({
        interval: null,
    }),
    mounted() {
        this.addPlugin(ChartDataLabels);
        this.renderChart(this.chartData, this.options);
        this.interval = setInterval(() => {
            if (this.$data._chart) {
                this.$data._chart.update()
            }
        }, 2000);
    },
    beforeDestroy() {
        clearInterval(this.interval)
    }
};